module.exports = __webpack_public_path__ + "static/media/horse.83b7b090.png";